import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavBarFlexbox = styled.div`
  display: flex;
  align-items: center;
  padding: 1em 0;
  height: 4.5em;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const FlexGrowPlaceholder = styled.div`
  flex-grow: 1;
`;

export const HeaderLogoImg = styled.img`
  height: 3em;
`;

export const ResponsiveUSMLogoLink = styled(Link)`
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: unset;
    margin-right: 1em;
  }
`;

export const ResponsiveSPMSMobileLogoLink = styled(Link)`
  @media screen and (min-width: ${props => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const ResponsiveSPMSWebLogoLink = styled(Link)`
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.mobile}) {
    display: unset;
  }
`;

export const ResponsiveUSMLogoImg = styled.img`
  display: none;
  height: 3em;

  @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: unset;
    margin-right: 1em;
  }
`;

export const ResponsiveSPMSMobileLogoImg = styled.img`
  height: 3em;

  @media screen and (min-width: ${props => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const ResponsiveSPMSWebLogoImg = styled.img`
  display: none;
  height: 3em;

  @media screen and (min-width: ${props => props.theme.breakpoints.mobile}) {
    display: unset;
  }
`;

export const HeaderLink = styled(Link)`
  padding: 0.25em 2em;
  margin: 1em;
  text-decoration: none;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;
  outline: 0;
  font-weight: ${props => props.theme.fontWeight.normal};
  border: 2px solid ${props => props.theme.color.headerLinkBorder};
  background-color: ${props => props.theme.color.headerLinkBackground};
  color: ${props => props.theme.color.headerLink};

  &:hover {
    background-color: ${props => props.theme.color.headerLinkHoverBackground};
    border: 2px solid ${props => props.theme.color.headerLinkHoverBorder};
    color: ${props => props.theme.color.headerLinkHover};
  }

  &:active {
    background-color: ${props => props.theme.color.headerLinkActiveBackground};
    border: 2px solid ${props => props.theme.color.headerLinkActiveBorder};
    color: ${props => props.theme.color.headerLinkActive};
  }
`;

export const HeaderIconLink = styled(Link)`
  padding: 0.25em 0.5em;
  margin: 1em;
  text-decoration: none;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;
  outline: 0;
  font-weight: ${props => props.theme.fontWeight.normal};
  border: 2px solid ${props => props.theme.color.headerLinkBorder};
  background-color: ${props => props.theme.color.headerLinkBackground};
  color: ${props => props.theme.color.headerLink};

  &:hover {
    background-color: ${props => props.theme.color.headerLinkHoverBackground};
    border: 2px solid ${props => props.theme.color.headerLinkHoverBorder};
    color: ${props => props.theme.color.headerLinkHover};
  }

  &:active {
    background-color: ${props => props.theme.color.headerLinkActiveBackground};
    border: 2px solid ${props => props.theme.color.headerLinkActiveBorder};
    color: ${props => props.theme.color.headerLinkActive};
  }
`;

export const HeaderClickableWrapper = styled.div`
  padding: 0.25em 0.5em;
  margin: 1em;
  text-decoration: none;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;
  outline: 0;
  font-weight: ${props => props.theme.fontWeight.normal};
  border: 2px solid ${props => props.theme.color.headerLinkBorder};
  background-color: ${props => props.theme.color.headerLinkBackground};
  color: ${props => props.theme.color.headerLink};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 10em;

  &:hover {
    background-color: ${props => props.theme.color.headerLinkHoverBackground};
    border: 2px solid ${props => props.theme.color.headerLinkHoverBorder};
    color: ${props => props.theme.color.headerLinkHover};
  }

  &:active {
    background-color: ${props => props.theme.color.headerLinkActiveBackground};
    border: 2px solid ${props => props.theme.color.headerLinkActiveBorder};
    color: ${props => props.theme.color.headerLinkActive};
  }
`;

export const Line = styled.div`
  border-bottom: solid 1.5px ${props => props.theme.color.headerBorder};
`;
